import { render } from "./_LinkButton.vue?vue&type=template&id=66d8af7c&scoped=true&lang=en"
import script from "./_LinkButton.vue?vue&type=script&lang=js"
export * from "./_LinkButton.vue?vue&type=script&lang=js"

import "./_LinkButton.vue?vue&type=style&index=0&id=66d8af7c&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d8af7c"]])

export default __exports__